import * as React from 'react'
 
import {ImageSkuBlock} from "@components";
import { useBuildExternalURL } from '@hooks'
 
 
export default function imageSkuColumn() {
    return {
        name: 'skuID', label: 'Product Image',
        options: {
			headerAlign: 'left',
            filter: false,
			customBodyRowRenderLite: (value, { skuName, productID, siteID, date }) => {
				const { imageURL } = useBuildExternalURL({
					imageData: { skuID: value, siteID, productID, date }
				})
				return <ImageSkuBlock
					imageURL={imageURL}
					skuName={skuName}
				/>
			}
        }
    }
}